module.exports = __webpack_public_path__ + "static/media/notif.d82eeda9.svg";